"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productCompare.name': '产品比较',
    'tools.productCompare.description': '从特定电子商务域名和网站比较产品',
};
